import { Pipe, PipeTransform } from '@angular/core';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { ReplaceMap } from 'src/lib/fliko/interfaces/replaceMap';
import { StrValue } from 'src/lib/fliko/types/typeish.type';
import { LocLabel, LocLabelModifier, parseLocLabelArgs } from '../components/clickable-row-table/models/data-table-config.models';

@Pipe({ name: 'toLL' })
export class LocLabelFactoryPipe implements PipeTransform {
  transform(src: string | LocLabel, modifier: StrValue<LocLabelModifier>): LocLabel;
  transform(src: string | LocLabel, replaceMap: ReplaceMap): LocLabel;
  transform(src: string | LocLabel, modifier: StrValue<LocLabelModifier>, replaceMap: ReplaceMap): LocLabel;
  // implementation
  transform(src: string | LocLabel, arg1: StrValue<LocLabelModifier> | ReplaceMap, arg2?: ReplaceMap): LocLabel {
    let old = src as LocLabel;
    if (StrHlp.isString(src)) old = { key: src as string };

    return { ...old, ...parseLocLabelArgs(arg1, arg2) };
  }
}
